/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MembersSecretariatCreateFromEmailInvite } from '../../models/members-secretariat-create-from-email-invite';
import { SecretariatInviteMembers } from '../../models/secretariat-invite-members';

export interface InviteSecretariatMembersApiV2SecretariatMembersMemberPost$Params {
  org: string;
      body: Array<MembersSecretariatCreateFromEmailInvite>
}

export function inviteSecretariatMembersApiV2SecretariatMembersMemberPost(http: HttpClient, rootUrl: string, params: InviteSecretariatMembersApiV2SecretariatMembersMemberPost$Params, context?: HttpContext): Observable<StrictHttpResponse<SecretariatInviteMembers>> {
  const rb = new RequestBuilder(rootUrl, inviteSecretariatMembersApiV2SecretariatMembersMemberPost.PATH, 'post');
  if (params) {
    rb.query('org', params.org, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SecretariatInviteMembers>;
    })
  );
}

inviteSecretariatMembersApiV2SecretariatMembersMemberPost.PATH = '/api/v2/secretariat/members/member';
